import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const CaseReadyV2 = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M7.0293 11.5884L7.0293 9.9668L2.48242 9.9668L2.48242 11.5884L7.0293 11.5884ZM7.7793 9.2168L1.73242 9.2168L1.73242 12.3384L7.7793 12.3384L7.7793 9.2168Z"
        fill={fill}
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M4.51821 2.32133C4.64984 2.57711 4.61124 2.87078 4.4963 3.14506C4.49101 3.15768 4.48504 3.17 4.47841 3.18196C4.38884 3.34352 4.34092 3.52484 4.33897 3.70955C4.33703 3.89427 4.38113 4.07656 4.46728 4.23996C4.56388 4.42316 4.49367 4.64998 4.31047 4.74657C4.25525 4.77568 4.19608 4.78964 4.1377 4.78993C4.1878 4.87356 4.20544 4.97653 4.17863 5.07824C4.12584 5.2785 3.9207 5.39806 3.72043 5.34527C3.19226 5.20605 2.71968 4.90778 2.36676 4.4909C2.36218 4.48549 2.35775 4.47995 2.35349 4.47429C2.1142 4.15677 2.00681 3.75908 2.05376 3.36427C2.10025 2.97328 2.29454 2.61504 2.59655 2.36284C2.95442 2.03451 3.48025 1.85434 3.90658 1.91644C4.12949 1.94891 4.38369 2.05995 4.51821 2.32133ZM3.80288 4.58791C3.65927 4.31479 3.58577 4.01025 3.58902 3.70167C3.59219 3.40016 3.66852 3.10404 3.81131 2.83873C3.84886 2.74447 3.85198 2.69312 3.85068 2.67152C3.84132 2.66755 3.82504 2.66248 3.79848 2.65861C3.62471 2.6333 3.31504 2.71862 3.09914 2.91959C3.09353 2.92482 3.08776 2.92987 3.08183 2.93474C2.92413 3.06445 2.82262 3.25006 2.79851 3.45283C2.7748 3.65225 2.82776 3.85311 2.94643 4.01482C3.17453 4.28108 3.47097 4.47903 3.80288 4.58791ZM3.86163 2.67786C3.8615 2.67795 3.86046 2.6773 3.85888 2.67565C3.86097 2.67695 3.86176 2.67777 3.86163 2.67786Z"
        fill={fill}
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M1.93773 5.37777C2.19352 5.2462 2.48721 5.28476 2.76157 5.39969C2.77419 5.40497 2.78651 5.41095 2.79848 5.41758C2.96 5.5071 3.14127 5.55499 3.32593 5.55693C3.51058 5.55887 3.69282 5.5148 3.85619 5.4287C4.0394 5.33213 4.26621 5.40238 4.36278 5.58559C4.39175 5.64055 4.4057 5.69944 4.4061 5.75755C4.48968 5.70748 4.59259 5.68982 4.69425 5.71658C4.89454 5.76928 5.01419 5.97436 4.96149 6.17465C4.82243 6.70314 4.52415 7.17606 4.10712 7.52922C4.1017 7.53381 4.09614 7.53825 4.09047 7.54252C3.77295 7.78181 3.37526 7.8892 2.98045 7.84225C2.58945 7.79576 2.23121 7.60147 1.97902 7.29946C1.6507 6.94159 1.47051 6.41574 1.53268 5.98937C1.56519 5.76641 1.67632 5.51224 1.93773 5.37777ZM4.20386 6.09325C3.93085 6.23672 3.62646 6.31013 3.31804 6.30689C3.01662 6.30372 2.72059 6.22743 2.45534 6.08472C2.36079 6.04707 2.30935 6.04401 2.28777 6.04534C2.2838 6.05469 2.27871 6.07097 2.27483 6.09759C2.2495 6.27131 2.33479 6.58097 2.53577 6.79687C2.541 6.80248 2.54605 6.80825 2.55092 6.81418C2.68063 6.97188 2.86624 7.07339 3.06901 7.0975C3.26842 7.12121 3.46927 7.06826 3.63097 6.9496C3.89715 6.7215 4.09502 6.42509 4.20386 6.09325ZM2.29409 6.03445C2.29418 6.03458 2.29353 6.03562 2.29188 6.0372C2.29318 6.03511 2.29401 6.03432 2.29409 6.03445Z"
        fill={fill}
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M5.33181 5.2035C5.38451 5.00321 5.5896 4.88356 5.78989 4.93626C6.31838 5.07532 6.79129 5.3736 7.14445 5.79063C7.14914 5.79618 7.15368 5.80186 7.15804 5.80766C7.39657 6.12501 7.5035 6.52213 7.45657 6.91634C7.41009 7.30679 7.21621 7.66459 6.91483 7.9167C6.55698 8.24509 6.03098 8.4254 5.60444 8.363C5.38133 8.33037 5.12726 8.21899 4.99291 7.95744C4.8615 7.70164 4.89997 7.4079 5.01486 7.13329C5.02016 7.1206 5.02617 7.10821 5.03284 7.09618C5.12241 6.93462 5.17033 6.7533 5.17227 6.56859C5.17421 6.38387 5.13011 6.20159 5.04396 6.03818C4.94737 5.85498 5.01758 5.62816 5.20078 5.53157C5.25511 5.50292 5.31329 5.48894 5.37076 5.48824C5.32224 5.40528 5.30542 5.30379 5.33181 5.2035ZM5.71066 5.6946C5.85276 5.9666 5.92545 6.26954 5.92223 6.57647C5.91906 6.87794 5.84274 7.17402 5.69999 7.4393C5.66207 7.53467 5.6592 7.58635 5.6606 7.60785C5.66991 7.61185 5.68622 7.61698 5.713 7.6209C5.88659 7.6463 6.19618 7.56107 6.4121 7.36007C6.41762 7.35493 6.4233 7.34996 6.42912 7.34516C6.58647 7.21549 6.68773 7.03014 6.71183 6.82768C6.73553 6.62865 6.68285 6.42817 6.56467 6.26659C6.33709 6.00109 6.04154 5.80357 5.71066 5.6946ZM5.64989 7.60159C5.65002 7.6015 5.65107 7.60216 5.65265 7.60382C5.65055 7.60251 5.64977 7.60168 5.64989 7.60159Z"
        fill={fill}
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M5.42399 2.73708C5.74134 2.49855 6.13846 2.39162 6.53267 2.43855C6.92313 2.48503 7.28092 2.67891 7.53303 2.98029C7.86142 3.33814 8.04173 3.86414 7.97934 4.29069C7.9467 4.51379 7.83532 4.76786 7.57378 4.90221C7.31797 5.03362 7.02424 4.99515 6.74962 4.88027C6.73695 4.87497 6.72457 4.86897 6.71256 4.86231C6.55104 4.77279 6.36977 4.7249 6.18511 4.72296C6.00045 4.72102 5.81821 4.76509 5.65485 4.85119C5.47163 4.94776 5.24482 4.87751 5.14826 4.6943C5.11916 4.6391 5.10521 4.57994 5.10493 4.52158C5.02114 4.57177 4.91794 4.58938 4.81608 4.56237C4.61589 4.50928 4.49664 4.30396 4.54973 4.10377C4.68992 3.57515 4.98946 3.10252 5.40765 2.75009C5.41298 2.74561 5.41843 2.74127 5.42399 2.73708ZM5.30721 4.18662C5.58021 4.04317 5.88459 3.96976 6.193 3.973C6.49439 3.97617 6.79038 4.05244 7.05561 4.19512C7.15099 4.23305 7.20269 4.23592 7.22419 4.23453C7.22818 4.22521 7.23332 4.2089 7.23723 4.18213C7.26263 4.00853 7.1774 3.69894 6.97641 3.48302C6.97126 3.4775 6.96629 3.47182 6.96149 3.466C6.83183 3.30866 6.64647 3.20739 6.44401 3.18329C6.24484 3.15958 6.04421 3.21235 5.88258 3.33071C5.61555 3.55838 5.41681 3.85466 5.30721 4.18662ZM7.21792 4.24523C7.21784 4.2451 7.21849 4.24405 7.22015 4.24248C7.21884 4.24457 7.21801 4.24536 7.21792 4.24523Z"
        fill={fill}
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M4.75508 4.56055C4.43568 4.56055 4.17676 4.81947 4.17676 5.13887C4.17676 5.45826 4.43568 5.71719 4.75508 5.71719C5.07447 5.71719 5.3334 5.45826 5.3334 5.13887C5.3334 4.81947 5.07447 4.56055 4.75508 4.56055ZM3.42676 5.13887C3.42676 4.40526 4.02147 3.81055 4.75508 3.81055C5.48869 3.81055 6.0834 4.40526 6.0834 5.13887C6.0834 5.87248 5.48869 6.46719 4.75508 6.46719C4.02147 6.46719 3.42676 5.87248 3.42676 5.13887Z"
        fill={fill}
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M15 0.75H1C0.861929 0.75 0.75 0.861929 0.75 1V13.5C0.75 13.6381 0.861929 13.75 1 13.75H15C15.1381 13.75 15.25 13.6381 15.25 13.5V1C15.25 0.861929 15.1381 0.75 15 0.75ZM1 0C0.447715 0 0 0.447715 0 1V13.5C0 14.0523 0.447715 14.5 1 14.5H15C15.5523 14.5 16 14.0523 16 13.5V1C16 0.447715 15.5523 0 15 0H1Z"
        fill={fill}
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M11.2983 2.70312H9.67676V7.25H11.2983V2.70312ZM8.92676 1.95312V8H12.0483V1.95312H8.92676Z"
        fill={fill}
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M13.7344 16C13.5273 16 13.3594 15.8321 13.3594 15.625L13.3594 0.375C13.3594 0.167893 13.5273 -2.54447e-08 13.7344 -1.63918e-08V-1.63918e-08C13.9415 -7.33885e-09 14.1094 0.167893 14.1094 0.375L14.1094 15.625C14.1094 15.8321 13.9415 16 13.7344 16V16Z"
        fill={fill}
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M3.36719 16C3.16008 16 2.99219 15.8321 2.99219 15.625L2.99219 14.2188C2.99219 14.0116 3.16008 13.8438 3.36719 13.8438V13.8438C3.57429 13.8438 3.74219 14.0116 3.74219 14.2188L3.74219 15.625C3.74219 15.8321 3.57429 16 3.36719 16V16Z"
        fill={fill}
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M2.99219 12.8027L2.99219 11.0703L3.74219 11.0703L3.74219 12.8027L2.99219 12.8027Z"
        fill={fill}
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M4.44531 12.8027L4.44531 11.0703L5.19531 11.0703L5.19531 12.8027L4.44531 12.8027Z"
        fill={fill}
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M5.85156 12.8027L5.85156 11.0703L6.60156 11.0703L6.60156 12.8027L5.85156 12.8027Z"
        fill={fill}
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M12.0483 9.80273H8.92676V9.05273H12.0483V9.80273Z"
        fill={fill}
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M12.0483 11.0703H8.92676V10.3203H12.0483V11.0703Z"
        fill={fill}
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M12.0483 12.3379H8.92676V11.5879H12.0483V12.3379Z"
        fill={fill}
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  );
};

CaseReadyV2.category = 'product-category';

CaseReadyV2.displayName = 'CaseReadyV2';
